module.exports = __webpack_public_path__ + "img/various-icon-a.045bf52d.png";